import * as types from './PetPointsTypes';

export default function PetPointsReducer(state, action) {
    const { type, payload } = action;

    switch (type) {
        case types.GET_PETPOINTS:
            return {
                ...state,
                getPetPoints: {
                    ...state.getPetPoints,
                    petPoints: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.GET_PETPOINTS_LOADING:
            return {
                ...state,
                getPetPoints: {
                    ...state.getPetPoints,
                    loading: true
                },
            };
        case types.GET_PETPOINTS_ERROR:
            return {
                ...state,
                getPetPoints: {
                    ...state.getPetPoints,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.GET_PETPOINTS_BY_ID:
            return {
                ...state,
                getPetPointsById: {
                    ...state.getPetPointsById,
                    petPoint: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PETPOINTS_BY_ID_LOADING:
            return {
                ...state,
                getPetPointsById: {
                    ...state.getPetPointsById,
                    loading: true
                },
            };
        case types.GET_PETPOINTS_BY_ID_ERROR:
            return {
                ...state,
                getPetPointsById: {
                    ...state.getPetPointsById,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_PET_POINTS_EVENTS:
            return {
                ...state,
                getPetPointsEvents: {
                    ...state.getPetPointsEvents,
                    petPointsEvents: payload.data,
                    firstPetPointsEvent: payload.first,
                    lastPetPointsEvent: payload.last,
                    nextPetPointsEvents: payload.next,
                    petPointsEventsFilter: [],
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PET_POINTS_EVENTS_LOADING:
            return {
                ...state,
                getPetPointsEvents: {
                    ...state.getPetPointsEvents,
                    loading: true
                },
            };
        case types.GET_PET_POINTS_EVENTS_ERROR:
            return {
                ...state,
                getPetPointsEvents: {
                    ...state.getPetPointsEvents,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.GET_PET_POINTS_EVENTS_MIGRATE:
            return {
                ...state,
                getPetPointsEventsMigrate: {
                    ...state.getPetPointsEventsMigrate,
                    petPointsEvents: payload.data,
                    petPointsEventsMigrate: payload.dataMigrate,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PET_POINTS_EVENTS_MIGRATE_LOADING:
            return {
                ...state,
                getPetPointsEventsMigrate: {
                    ...state.getPetPointsEventsMigrate,
                    loading: true
                },
            };
        case types.GET_PET_POINTS_EVENTS_MIGRATE_ERROR:
            return {
                ...state,
                getPetPointsEventsMigrate: {
                    ...state.getPetPointsEventsMigrate,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
            case types.MIGRATE_PET_POINT_EVENT:
            return {
                ...state,
                migratePetPointEvents: {
                    ...state.migratePetPointEvents,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.MIGRATE_PET_POINT_EVENT_LOADING:
            return {
                ...state,
                migratePetPointEvents: {
                    ...state.migratePetPointEvents,
                    loading: true
                },
            };
        case types.MIGRATE_PET_POINT_EVENT_ERROR:
            return {
                ...state,
                migratePetPointEvents: {
                    ...state.migratePetPointEvents,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.MIGRATE_PET_POINT_EVENT_RESET_STATE:
            return {
                ...state,
                migratePetPointEvents: {
                    ...state.migratePetPointEvents,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PET_POINTS_EVENTS_APPLICATION:
            return {
                ...state,
                getPetPointsEventsApplication: {
                    ...state.getPetPointsEventsApplication,
                    petPointsEventsApplication: payload.data,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.GET_PET_POINTS_EVENTS_APPLICATION_LOADING:
            return {
                ...state,
                getPetPointsEventsApplication: {
                    ...state.getPetPointsEventsApplication,
                    loading: true
                },
            };
        case types.GET_PET_POINTS_EVENTS_APPLICATION_ERROR:
            return {
                ...state,
                getPetPointsEventsApplication: {
                    ...state.getPetPointsEventsApplication,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    },
                },
            };
        case types.CREATE_PET_POINT_EVENT:
            return {
                ...state,
                createPetPointEvents: {
                    ...state.createPetPointEvents,
                    petPointEvent: payload,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.CREATE_PET_POINT_EVENT_LOADING:
            return {
                ...state,
                createPetPointEvents: {
                    ...state.createPetPointEvents,
                    loading: true
                },
            };
        case types.CREATE_PET_POINT_EVENT_ERROR:
            return {
                ...state,
                createPetPointEvents: {
                    ...state.createPetPointEvents,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.CREATE_PET_POINT_EVENT_RESET_STATE:
            return {
                ...state,
                createPetPointEvents: {
                    ...state.createPetPointEvents,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.UPDATE_PET_POINT_EVENT:
            return {
                ...state,
                updatePetPointEvents: {
                    ...state.updatePetPointEvents,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.UPDATE_PET_POINT_EVENT_LOADING:
            return {
                ...state,
                updatePetPointEvents: {
                    ...state.updatePetPointEvents,
                    loading: true
                },
            };
        case types.UPDATE_PET_POINT_EVENT_ERROR:
            return {
                ...state,
                updatePetPointEvents: {
                    ...state.updatePetPointEvents,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.UPDATE_PET_POINT_EVENT_RESET_STATE:
            return {
                ...state,
                updatePetPointEvents: {
                    ...state.updatePetPointEvents,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.DELETE_PET_POINT_EVENT:
            return {
                ...state,
                deletePetPointEvent: {
                    ...state.deletePetPointEvent,
                    loading: false,
                    hasSuccess: true,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
            };
        case types.DELETE_PET_POINT_EVENT_LOADING:
            return {
                ...state,
                deletePetPointEvent: {
                    ...state.deletePetPointEvent,
                    loading: true
                },
            };
        case types.DELETE_PET_POINT_EVENT_ERROR:
            return {
                ...state,
                deletePetPointEvent: {
                    ...state.deletePetPointEvent,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: payload.code,
                        message: payload.message
                    }
                },
            };
        case types.DELETE_PET_POINT_EVENT_RESET_STATE:
            return {
                ...state,
                deletePetPointEvent: {
                    ...state.deletePetPointEvent,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
        case types.PET_POINTS_RESET_STATE:
            return {
                getPetPoints: {
                    petPoints: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getPetPointsById: {
                    petPoint: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getPetPointsByAlly: {
                    petPoint: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getPetPointsEvents: {
                    petPointsEvents: [],
                    firstPetPointsEvent: null,
                    lastPetPointsEvent: null,
                    nextPetPointsEvents: null,
                    petPointsEventsFilter: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                getPetPointsEventsMigrate: {
                    petPointsEvents: [],
                    petPointsEventsMigrate: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    }
                },
                migratePetPointEvents: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                getPetPointsEventsApplication: {
                    petPointsEventsApplication: [],
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                createPetPointEvents: {
                    petPointEvent: null,
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                deletePetPointEvent: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
                updatePetPointEvents: {
                    loading: false,
                    hasSuccess: false,
                    hasError: {
                        code: null,
                        message: null
                    },
                },
            };
    
        default:
            return state;
    }
}